/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Table(theme: Theme): any {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: theme.palette.action.selected,
            "&:hover": { backgroundColor: theme.palette.action.hover },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottom: 0 },
        head: { color: theme.palette.grey[800], backgroundColor: theme.palette.grey[300] },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        select: { "&:focus": { borderRadius: theme.shape.borderRadius } },
        selectIcon: { width: 20, height: 20, marginTop: 2 },
      },
    },
  };
}
